import { View } from 'react-native';

import {
  QuantityStepperDecreaseButton,
  QuantityStepperFloatingContainer,
  QuantityStepperIncreaseButton,
  QuantityStepperQuantity,
  QuantityStepperToggleButton,
} from './components';

export const QuantityStepperV2 = {
  ToggleButton: QuantityStepperToggleButton,
  IncreaseButton: QuantityStepperIncreaseButton,
  DecreaseButton: QuantityStepperDecreaseButton,
  Container: View,
  FloatingContainer: QuantityStepperFloatingContainer,
  Quantity: QuantityStepperQuantity,
};
